import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { FaseService } from '../../fase/fase.service';

@Component({
  templateUrl: './relatorio-inscritos.component.html',
})
export class RelatorioInscritosComponent extends WebPage implements OnInit {

  fases;
  unidadesInscritos;

  form: FormGroup;
  constructor(private fb: FormBuilder, private faseService: FaseService, messageService: MessageService) {
    super(messageService);

    this.form = this.fb.group({
      idFase: [null, Validators.required],
      dataInicial: [null, Validators.required],
      dataFinal: [null, Validators.required],
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.faseService.getAll()
      .finally(() => this.isLoading = false)
      .subscribe(
        fases => this.fases = fases,
        error => this.gerenciaErro(error)
    );
  }

  submit() {
    if (this.form.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Formulário preenchido incorretamente.' });
      return false;
    }

    this.isLoading = true;
    this.faseService.getRelatorioInscritos(this.form.value)
      .finally(() => this.isLoading = false)
      .subscribe(
        unidadesInscritos => {
          this.unidadesInscritos = unidadesInscritos;

          if (unidadesInscritos.every(ui => ui.numeroInscritos === 0)) {
            this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Nenhum registro encontrado!' });
          }
        },
        error => this.gerenciaErro(error)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/relatorio-inscritos/relatorio-inscritos.component.ts